import Vue from 'vue'
import Vuex from 'vuex'
// import createPersistedState from 'vuex-persistedstate'
import { roomOrder } from '@/module/store/modules/roomOrder'
// import { auth } from '@/module/store/modules/auth'

Vue.use(Vuex)

Vuex.Store.prototype.hasModule = function (module) {
  return this._modules.root._children[module] !== undefined
}
const store = function () {
  return new Vuex.Store({
    // plugins: [createPersistedState()],
    modules: {
      roomOrder: roomOrder()
      // auth: auth()
    }

  })
}

export { store }
